export const QUERIES_RESPONSE_FORM = 'QueriesResponseForm';
export const QUERIES_RESPONSE_SEARCH = 'QueriesResponseSearch';
